import type { ReactNode } from '@frontend/react';
import { PaymentStepProvider } from '@frontend/react-domain';
import { useWebPaymentDependencies } from '@frontend/web-react';
import {
  useAnalytics,
  useBuyCreditsMutation,
  useCreateSetupIntentMutation,
  useLazyListCardsQuery,
  useRetrieveClientQuery,
  useSetupIntentConfirmedMutation,
  useStripeCard,
  useUpdatePlanMutation,
} from '@frontend/web/hooks';
import { handleMutation } from '@frontend/web/utils';
import { PaywallPricingProvider } from '../PaywallPricingContext';

export const PaywallPaymentScope = ({ children }: { children: ReactNode }) => {
  const { track, trackAdvertising } = useAnalytics();
  const webStripeCard = useStripeCard();

  const paymentDependencies = useWebPaymentDependencies({
    handleMutation,
    track,
    trackAdvertising,
    useBuyCreditsMutation,
    useCreateSetupIntentMutation,
    useLazyListCardsQuery,
    useRetrieveClientQuery,
    useSetupIntentConfirmedMutation,
    useUpdatePlanMutation,
    webStripeCard,
  });

  return (
    <PaymentStepProvider dependencies={paymentDependencies}>
      <PaywallPricingProvider>{children}</PaywallPricingProvider>
    </PaymentStepProvider>
  );
};
